//Boilerplate FlexiGrid

//    About: This is meant to demonstrate the technologies built into FlexiGrid. The overall idea is that we can feed FlexiGrid our configuration as well as custom buttons, functions, etc
//    and have it generate us a nice grid, complete with sorting, paging, input-lockout, status, in-line edits, and more.
//    Below we do include some things that are used for rendering when we want to send custom configuration to FlexiGrid


//React & Friends
import React, { useState, useEffect, useContext, useRef } from 'react';

import FlexiGrid from '../common/FlexiGrid/FlexiGrid';

//Doublecheck everything below this line. All from old boilerplate table.
import { useLocation, useHistory } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';

//Contexts
//AuthContext
import { AppContext } from "../Auth/contexts/AppContext"

//CSS Styles
import flexstyles from '../../css/FlexCss';
import useClasses from '../../ui/useClasses';

//Datetime formatting
import dayjs from 'dayjs'; //Used with new datetimepickers


//MaterialUI
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';



const BoilerplateFlexiGrid = () => {
	/* CSS and Media Queries */
	const classes = useClasses(flexstyles);

	/* App Context */
	/* Allows userperms to be used */
	const appContext = useContext(AppContext);
	const { userPerms, userRole } = appContext;


	/* ##########################  CUSTOM FUNCTIONS  ########################## */
	const CustomPrice = ({ localstate, index, columnindex, classes, UpdateState  }) => {
		return (
			<span style={{fontWeight:"bold", color:"blue"}}>
				{localstate.griditems[index]["Price"]}
			</span>
		);
	}; 

	const BulkMutatorBtn = ({ localstate, index, columnindex, classes, UpdateState }) => {
		const ApplyBulkMutation = (localstate, UpdateState) => {
			for (var i=0; i<localstate.griditems.length; i++){
				localstate.griditems[i].Price = 666; //Or do some calculation based the current griditems values. 
			}
			UpdateState(localstate);
		}
		return (
			<span style={{ fontWeight: "bold", color: "blue" }}>
				<Button
					className={classes.bluebtn}
					style={{margin:"0px", padding:"3px 3px 2px 3px"}}
					color="primary" variant="contained"
					onClick={() => ApplyBulkMutation(localstate, UpdateState)}>
					Bulk Mutate Price
				</Button>
			</span>
		);
	}; 

	//Custom for onChange of items in edit mode
	const onChangeCost = ({localstate, index, column, rowRefs}) => {
		rowRefs.current[index+"Margin"].textContent = localstate.griditems[index]["Margin"] = (parseFloat(localstate.griditems[index]["Price"]) - parseFloat(localstate.griditems[index]["Cost"])).toFixed(2);
	}

	/* ##########################  SEARCH INPUT DEFAULTS  ########################## */
	// These establish the baseline for the page search inputs.
	//Container and Key Sizes for Search Inputs
	const containersizes = "260px";
	const keysizes = "180px";

	var inputdefaults = { 
		Name: {
			type: "Name",
			value: "", //Example name parameter from URL
			mode: "like",
			orable: false,
			uuid: uuidv4(),
			container: containersizes,
			keysize: keysizes,
			grow: 1, //Allows input to grow with typed input?!
		},
		//Products AutoComplete - Autocompletes are always or-able
		products: {
			type: "products",
			keyedby: "ProductID", //We'll need a key so that Autocomplete can highlight our value in the drop down after selection
			searchkey: "Name", //This is the column we are searching from the table
			value: [],
			multiple: true,
			//inputValue:"", //Text Search! This *CAN* be used... but seems nicer without it!
			mode: "autocomplete",
			orable: true,
			defaultsearchterm: "70",
			limit: 10, //Database return limit, keep below ~100
			uuid: uuidv4(),
			container: containersizes,
			keysize: keysizes,
			grow: 1,
			debouncetime: 0 //Not a lot of typing or results.
		},
		NotName: {
			type: "NotName",
			value: "",
			mode: "not",
			orable: false,
			uuid: uuidv4(),
			container: containersizes,
			keysize: keysizes,
			grow: 1,
		},
		//Standard DateTimeAfter
		DateTimeAfter: {
			type: "DateTimeAfter",
			value: (() => {
				// let date = new Date();
				// date.setFullYear(date.getFullYear() - 50); //Set to 50 years ago
				// return date;
				return dayjs().subtract(10, 'year');

			})(),
			mode: "datetimeafter",
			orable: false,
			uuid: uuidv4(),
			container: containersizes,
			keysize: keysizes,
			grow: 1,
		},
		//Standard DateTimeBefore
		DateTimeBefore: {
			type: "DateTimeBefore",
			value: dayjs(), //new Date, 
			mode: "datetimebefore",
			orable: false,
			uuid: uuidv4(),
			container: containersizes,
			keysize: keysizes,
			grow: 1,
		},
		//Example AutoComplete - Components can take optional "producttype" to narrow between product types.
		components: {
			type: "components",
			keyedby: "ID", //We'll need a key so that Autocomplete can highlight our value in the drop down after selection
			searchkey: "Name", //This is the column we are searching from the table
			producttype: "Desktop",
			value: [],
			mode: "autocomplete",
			orable: true,
			defaultsearchterm: "",
			limit: 10, //Database return limit, keep below ~100
			uuid: uuidv4(),
			container: containersizes,
			keysize: keysizes,
			grow: 1,
		},
		'Cost >': {
			type: "Cost >",
			value: "",
			mode: "greaterthan",
			orable: false,
			uuid: uuidv4(),
			container: containersizes,
			keysize: keysizes,
			grow: 1,
		},
		'Cost <': {
			type: "Cost <",
			value: "",
			mode: "lessthan",
			orable: false,
			uuid: uuidv4(),
			container: containersizes,
			keysize: keysizes,
			grow: 1,
		},
		NewCheckbox: {
			type: "NewCheckbox",
			value: "",
			mode: "bool",
			orable: false,
			uuid: uuidv4(),
			container: containersizes,
			keysize: keysizes,
			grow: 1,
		},
		NameStrict: {
			type: "Name",
			value: "",
			mode: "strict",
			orable: false,
			uuid: uuidv4(),
			container: containersizes,
			keysize: keysizes,
			grow: 1,
		},
		SomeSelectable: {
			type: "SomeSelectable",
			value: [],
			mode: "select",
			orable: true,
			//Select Menu Items:
			menuitems: [
				{
					value: "",
					key: uuidv4(),
					text: "-",
					usechip: false
				},
				{
					value: 10,
					key: uuidv4(),
					text: "Ten (integer)",
					usechip: false
				},
				{
					value: "A",
					key: uuidv4(),
					text: "A",
					//Optional usechip - Overrides text
					usechip: true,
					chipsize: "small",
					chiplabel: "Grade A",
					chipclass: classes.gradea, //Test this.		
					//Optional Chip Height and Centering:
					height: "22px",
					center: true,
				},
				{
					value: "B",
					key: uuidv4(),
					text: "B",
					//Optional usechip - Overrides text
					usechip: true,
					chipsize: "small",
					chiplabel: "Grade B",
					chipclass: classes.gradeb, //Test this.		
					//Optional Chip Height and Centering:
					height: "22px",
					center: true,
				},
				{
					value: "C",
					key: uuidv4(),
					text: "C",
					//Optional usechip - Overrides text
					usechip: true,
					chipsize: "small",
					chiplabel: "Grade C",
					chipclass: classes.gradec, //Test this.		
					//Optional Chip Height and Centering:
					height: "22px",
					center: true,
				},
				{
					value: "Bad",
					key: uuidv4(),
					text: "Bad",
					//Optional usechip - Overrides text
					usechip: true,
					chipsize: "small",
					chiplabel: "Bad",
					chipclass: classes.gradebad, //Test this.		
					//Optional Chip Height and Centering:
					height: "22px",
					center: true,
				},
				{
					value: "Repair",
					key: uuidv4(),
					text: "Repair",
					//Optional usechip - Overrides text
					usechip: true,
					chipsize: "small",
					chiplabel: "Repair",
					chipclass: classes.graderepair, //Test this.		
					//Optional Chip Height and Centering:
					height: "22px",
					center: true,
				},
				{
					value: "Scrap",
					key: uuidv4(),
					text: "Scrap",
					//Optional usechip - Overrides text
					usechip: true,
					chipsize: "small",
					chiplabel: "Scrap",
					chipclass: classes.gradeb, //Test this.		
					//Optional Chip Height and Centering:
					height: "22px",
					center: true,
				},
			],
			uuid: uuidv4(),
			container: containersizes,
			keysize: keysizes,
			//Experimental Multiple!
			multiple: true,//Change 'value' to array if true.
			center: true,
			grow: 1,
			usechips: true
		},
	};

	/* ########################## Custom Parameters: Modify Per-Controller  ##########################

	 Each new table will likey have very different parameters. Handle them before configuration.

	Concept: We have this really complicated search input system. When a page is linked with URL parameters, let's marshall each 
	key-value pair into new defaults based on input defaults.

	Possibly clear the URL before rendering inputs and page?

				*/

	//This controls how many inputs we need to fill for the page. Often we simply use 4 or 8, but we'll try and modify the code to be able to use any values.
	const minimuminputs = 4;
	const maximuminputs = 8;		

	

	
	const params = new URLSearchParams(useLocation().search);

	const urlparams = Array.from(params.entries());


	//		AUTOCOMPLETEPAIRS
	//		If you are not using auto-complete search inputs, you may simply comment the array inside autocompletepairs.
	// 		This is a special array. It is structured to allow a key-value pair shortcut to pre-fill a search input with label!
	//		Logic below also removes the need to add the search input type - when an autocomplete pair is found our custom array's third argument allows us to understand the search input type!
	//		Database compatibility: Autocompletes are typically driven by the searchinputtype as well, see DBAutoComplete.php
	// 		URL Params Compatiblity: Any link generator will need to follow the pattern of the autocompletepair. In this example, ProductID then Name and always in that order.
	// 
	// 
	// 		The structure of the array of arrays is:
	//		----------------------------------------------------------------------------------------------------------------------------------------------------------------------
	//		keyedby: "ProductID", //We'll need a key so that Autocomplete can highlight our value in the drop down after selection. This is often how the DB will load the items.
	//		searchkey: "Name", //This is the column we are searching from the table, often a friendly name
	//		searchinputtype:  The searchinput that we're pre-filling. Having this assigned means we won't ever need to reference it as a URL parameter!
	//		[[keyedby, searchkey, searchinputtype],[keyedby, searchkey, searchinputtype],...]


	const autocompletepairs = [
		['ProductID', 'Name', 'products'], //This will not only fetch from the DB correctly, but it will render the current value without a DB call!

	]

	const configuredinputs = []; //This is where we'll hold 
	var currentconfiguration = {}; 
	var combine = false;
	//This itterates the parameters in sequential order. We need to have flags to check for pairs...
	for (let i = 0; i < urlparams.length; i++) {
		//With urlparams, 0 is the key, and 1 is the value.
		//Use current entry and check that it is or isn't an auto-complete pair
		for (let j=0; j<autocompletepairs.length; j++){
			if (urlparams[i][0]===autocompletepairs[j][0]){
				//Doublecheck for next value!
				if (urlparams[i+1] && urlparams[i+1][0]===autocompletepairs[j][1]){
					//alert("Found matching: "+autocompletepairs[j][1]);
					currentconfiguration = Object.assign({}, inputdefaults[autocompletepairs[j][2]]); //Source must exist above. This example, we're cloning the 'products' search input.
					//This example is interpereted as : currentconfiguration = Object.assign({}, inputdefaults['products']);
					
					//Check if we should add our new configuration to an existing one.
					combine=false;
					for (var p=0;p<configuredinputs.length; p++){
						console.log(configuredinputs);
						console.log(currentconfiguration);
						if (configuredinputs[p].type===currentconfiguration.type){
							combine = true;
							//Modify existing configured input
							configuredinputs[p].value.push({
								[urlparams[i][0]]: urlparams[i][1],
								[urlparams[i + 1][0]]: urlparams[i + 1][1]
							})
						}
					}

					if (!combine){
						//Override value:
						currentconfiguration.value = [
							{
								[urlparams[i][0]]: urlparams[i][1],
								[urlparams[i + 1][0]]: urlparams[i + 1][1]
							}
						];
						//Push to configured inputs
						configuredinputs.push(currentconfiguration);
					}
					console.log("Autocomplete found for: "+autocompletepairs[j][2]);
					//Since we consumed the second half of the URL parameter for the autocomplete, we skip the next URL entry!
					i++;
				}
			}
		}
	}

	//console.log(configuredinputs);

	//If configured inputs is less than the minimum, we need to fill the remainder with appropriately available search inputs, preset to commonly used ones that aren't already specified in URL parameters!
	//First we'll need a search input priority array:
	var priorityarray = [
		"Name",
		"products",
		"DateTimeAfter",
		"DateTimeBefore",
		"components",
		"Cost <",
		"NewCheckbox",
		"SomeSelectable"
	];

	//Make a copy of this array so we can use it for resets!
	var resetarray = Object.assign({}, priorityarray);

	var k=0;
	var l=0;
	var finalinputs=[]; //Configure a variable to send to configuration!
	if (configuredinputs.length<minimuminputs){
		for (var k=0; k<configuredinputs.length; k++){
			finalinputs.push(configuredinputs[k]);
			//Loop configured inputs and remove any priority items that are already handled!
			for (var m=0; m<priorityarray.length; m++){
				if (configuredinputs[k].type===priorityarray[m]){
					// console.log("################################################");
					// console.log(priorityarray[m]);
					// console.log(configuredinputs[k]);
					priorityarray.splice(m,1);
				}
			}
		}
	}

	//We can now itterate over the other priority inputs and fill in the next most important ones that weren't already sliced off the array.
	for (k=0; k<priorityarray.length; k++){
		finalinputs.push(inputdefaults[priorityarray[k]]);
	}


	console.log("$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$");
	console.log(finalinputs);







	// checkparameters.forEach(checkparameter =>{
	// 	parameterarray = params.getAll(checkparameter);
	// 	if (parameterarray.length) {
	// 		parameterarray.forEach(parameter => {
	// 			// Do something with each name
	// 			console.log(parameter);
	// 			//Create new configuration
	// 			currentconfiguration = Object.assign({}, inputdefaults[checkparameter]); //Source must exist above.
	// 			currentconfiguration.value = parameter;
	// 			configuredinputs.push(currentconfiguration);
	// 		});
	// 	}
	// });



	/* ##########################  Configuration  ########################## */
	//Perms - Be sure endpoints are secure because this certainly isn't. These are for perm driven views, not the perms on data.
	var perms = {
		createPerm:(userPerms['createDemoData']===1 ? true : false),
		readPerm:(userPerms['readDemoData']===1 ? true : false),
		updatePerm:(userPerms['updateDemoData']===1 ? true : false),
		deletePerm:(userPerms['deleteDemoData']===1 ? true : false),
	}



	//Grid Configuration
	const configuration = {
		//PAGE OPTIONS
		showtitle:true,
		title: "Boilerplate FlexiGrid",
		 
		//DATA OPTIONS
		apiendpoint: "/flexigrid/",
		dbmodel:"basictable", //or flexproduct, flexorder, etc	
		itemskey:"ID",
		nestedrelationships:[
			'creationuser',
			'updateuser',
			'deletionuser',
			'product'
		],

		//Datetimes to handle
		datetimes:[
			'DateTime',
		],




		//TABLE OPTIONS
		tablebordertype: "thin", //open (no borders like on Products), thin (Main tables, darker border), thick (Order Details has all thick and lighter gray border tables)
		showcolumnheaders:true,
		maxrowseditmode:100,
		//DB Support items (try to add supports to DB tables when it's helpful)
		softdeletesupport:true,
		creationusersupport:true,
		updateusersupport:true,
		deleteusersupport:true,



		//Search Input Settings
		defaultselectinputs: [
			{ value: "Name", text: "Name" },
			{ value: "NotName", text: "Not Name" },
			{ value: "DateTimeAfter", text: "Date Time After" },
			{ value: "DateTimeBefore", text: "Date Time Before" },
			{ value: "Cost >", text: "Cost >" },
			{ value: "Cost <", text: "Cost <" },
			{
				value: "products", text: "", html: () => {
					return (
						<span><span style={{ fontWeight: "bold", color: "green" }}>NEW</span> search by Products</span>
					);
				}
			},
			{ value: "components", text: "Component" },
			{ value: "NewCheckbox", text: "Checkbox Bool" },
			{ value: "NameStrict", text: "Name Strict" },
			{ value: "SomeSelectable", text: "Some Selectable" }
		],
	

		//Keep a copy of the default inputs just in case the user wants to "reset" the page
		inputdefaults:inputdefaults, //ToDo: Change this to final inputs!
		resetarray:resetarray,
		//Send a copy of configuredinputs
		configuredinputs:finalinputs,

		//Search by & order
		orderby: "Name",
		order: "asc",

		// //Default Search Inputs (up to 8),
		// input1: "Name",
		// input2: "products",
		// input3: "DateTimeAfter",
		// input4: "DateTimeBefore",
		// input5: "components",
		// input6: "Cost <",
		// input7: "NewCheckbox",
		// input8: "SomeSelectable",

		//Columns describe the renderable columns
		columns: [
			{
				field: "Checkbox",
				visible: true,
				columnheader: "maincheckbox",
				currentlyeditable:true,
				render: "maincheckbox", //Special, does not need extended config
				borders:"all",
				columnoption:false,
				columnoptionlabel:"Checkbox"

			},
			{
				field: "Name", // or "key" or "name"
				visible: true,
				columnheader: "text",
				columnheadertext: "Name",
				columnheaderalign: "left", //left, right, center
				columnheaderstyle: { width: "400px" }, //Raw inline css
				valuetextalign:"left",
				allowsort: true,
				defaultsortorder: "asc",
				editable: false,
				requiresref:false,
				validationmethod:"text", // "text"....
				maxlength:10, //Validation....
				render:"textlink", // "textlink", Requires linkid (used as value in url), target, and linkendpoint
				linkid:"ID",
				linkendpoint:"/boilerplatekeyvalues/",
				target:"_blank",
				borders:"all", 
				columnoption:true,
				columnoptionlabel:"Name"
			},
			{
				field: "Cost",
				visible: true,
				columnheader: "text", //Requires columnheadertext and allowsort
				columnheadertext: "Cost",
				columnheaderalign: "right", //left, right, center
				columnheaderstyle: { width: "400px" }, //Raw inline css
				valuetextalign:"right",
				allowsort: true,
				defaultsortorder: "asc",
				editable: true,
				requiresref:false,
				validationmethod:"positivedecimal2", // "text", "positivedecimal2"
				onChange:onChangeCost,
				//maxvalue:, //Not needed for some validations.
				render: "number",
				step:"0.01",
				borders:"noright",
				columnoption:true,
				columnoptionlabel:"Cost"
			},
			{
				field: "Price",
				visible: true,
				columnheader: "text", //Requires columnheadertext and allowsort
				columnheadertext: "Price",
				columnheaderalign: "right", //left, right, center
				columnheaderstyle: { width: "400px" }, //Raw inline css
				valuetextalign:"right",
				allowsort: true,
				defaultsortorder: "asc",
				editable: true,
				requiresref:false,
				validationmethod:"positivedecimal2", // "text", "positiveinteger", "positivedecimal2"
				//maxvalue:, //Not needed for some validations.
				render: "customelement",
				customelement:CustomPrice,
				borders:"all",
				columnoption:true,
				columnoptionlabel:"Price"
			},
			{
				field: "CustomBtn",
				visible: true,
				columnheader: "text", //Requires columnheadertext and allowsort
				columnheadertext: "CustomBtn",
				columnheaderalign: "center", //left, right, center
				columnheaderstyle: { width: "400px" }, //Raw inline css
				valuetextalign:"center", //This can help also anchor any children, even buttons
				allowsort: true,
				defaultsortorder: "asc",
				editable: false,
				requiresref:false,
				render: "customelement",
				customelement:BulkMutatorBtn,
				borders:"all",
				columnoption:true,
				columnoptionlabel:"Custom Btn"
			},
			{
				field: "Margin",
				visible: true,
				columnheader: "text", //Requires columnheadertext and allowsort
				columnheadertext: "Margin",
				columnheaderalign: "right", //left, right, center
				columnheaderstyle: { width: "400px" }, //Raw inline css
				valuetextalign:"right",
				allowsort: true,
				defaultsortorder: "asc",
				editable: false, 
				requiresref:true, //Margin isn't editable... but we still need to be able to update it in view when Price or Cost changes.
				render:"text",
				borders:"noleft",
				columnoption:true,
				columnoptionlabel:"Margin"
			},
			{
				field: "PositiveInteger",
				visible: true,
				columnheader: "text", //Requires columnheadertext and allowsort
				columnheadertext: "PInt",
				columnheaderalign: "left", //left, right, center
				columnheaderstyle: { width: "400px" }, //Raw inline css
				valuetextalign:"center",
				allowsort: true,
				defaultsortorder: "asc",
				editable: true,
				requiresref:false,
				validationmethod:"positiveinteger", // "text", "positiveinteger", "positivedecimal2"
				render: "text",
				borders:"all",
				columnoption:true,
				columnoptionlabel:"P Int"
			},
			{
				field: "SomeBoolean",
				visible: true,
				columnheader: "text", //Requires columnheadertext and allowsort
				columnheadertext: "SomeBoolean",
				columnheaderalign: "center", //left, right, center
				columnheaderstyle: { width: "400px" }, //Raw inline css
				valuetextalign:"center",
				allowsort: true,
				defaultsortorder: "asc",
				editable: true,
				requiresref:false,
				render: "checkbox",
				validationmethod:"checkbox",
				borders:"all",
				columnoption:true,
				columnoptionlabel:"Some Bool"
			},
			{
				field: "SomeSelectable",
				visible: true,
				columnheader: "text", //Requires columnheadertext and allowsort
				columnheadertext: "SomeSelectable",
				columnheaderalign: "left", //left, right, center
				columnheaderstyle: { width: "400px" }, //Raw inline css
				valuetextalign:"left",
				allowsort: true,
				defaultsortorder: "asc",
				editable: true,
				requiresref:false,
				render: "select", //Requires Selections:
				selectoptions:[
					{value:0, text:"Zero", useCustomOption:false},
					{value:"None", text:"None", useCustomOption:false},
					{value:"", text:"Blank", useCustomOption:false},
					{value:10, text: "10", useCustomOption:false},
					{value:"Adam", text:"Adam", useCustomOption:true, customOption:()=>{return <MenuItem value={"Adam"}><div style={{borderRadius:"5px", color:"#FFF", backgroundColor:"#45b84a", padding:"2px 5px 0px 5px"}}>Adam Taylor</div></MenuItem>;}},
					{value:"A", text:"Grade A", useCustomOption:true, customOption:()=>{return <MenuItem value={"A"}><div style={{borderRadius:"5px", color:"#FFF", backgroundColor:"#45b84a", padding:"2px 5px 0px 5px"}}>Grade A</div></MenuItem>;}},
					{value:"B", text:"Grade B", useCustomOption:true, customOption:()=>{return <MenuItem value={"B"}><div style={{borderRadius:"5px", color:"#FFF", backgroundColor:"#ccb136", padding:"2px 5px 0px 5px"}}>Grade B</div></MenuItem>;}},
					{value:"C", text:"Grade C", useCustomOption:true, customOption:()=>{return <MenuItem value={"C"}><div style={{borderRadius:"5px", color:"#FFF", backgroundColor:"#ce823e", padding:"2px 5px 0px 5px"}}>Grade C</div></MenuItem>;}},
					{value:"Repair", text:"Repair", useCustomOption:true, customOption:()=>{return <MenuItem value={"Repair"}><div style={{borderRadius:"5px", color:"#FFF", backgroundColor:"#e9523a", padding:"2px 5px 0px 5px"}}>Repair</div></MenuItem>;}},
					{value:"Scrap", text:"Scrap", useCustomOption:true, customOption:()=>{return <MenuItem value={"Scrap"}><div style={{borderRadius:"5px", color:"#FFF", backgroundColor:"#777", padding:"2px 5px 0px 5px"}}>Scrap</div></MenuItem>;}},
					{value:"Unknown", text:"Unknown", useCustomOption:true, customOption:()=>{return <MenuItem value={"Unknown"}><div style={{borderRadius:"5px", color:"#FFF", backgroundColor:"#999", padding:"2px 5px 0px 5px"}}>Unknown</div></MenuItem>;}},
				],
				borders:"noright",
				columnoption:true,
				columnoptionlabel:"Some Select"
			},
			{
				field: "ProductID", //CONVERT THIS FROM products TO ProductID
				visible: true,
				columnheader: "text", //Requires columnheadertext and allowsort
				columnheadertext: "Product",
				columnheaderalign: "left", //left, right, center
				columnheaderstyle: { width: "400px" }, //Raw inline css
				valuetextalign:"left",
				allowsort: true,
				defaultsortorder: "asc",
				editable: true, //Autocompletes are typically true... when not being edited, it'll be rendering text based on childrelationship t/f and saveas.
				requiresref:false,
				render: "autocomplete", //Requires "searchtype", "searchby" and "savevalue", "childrelationship", "nestedmodel", endadornment, autocompletelimit, autocompletestatic
					//SearchType: This is typically something that is configured within DBAutoComplete.php to help along different types of values we handle - helps reuse code.
					//SearchBy: This is typically the string value we're looking for - it also drives our rendered value - it ALSO drives the value derived to render from a child relationship.
					//SaveValue: This is how we'd like to save to the current row. For example in some cases we'd like the "ProductID" to link the relationship, but in others we might want "Name" as a simple string value. (ProductName)
					//ChildRelationship: Boolean
					//NestedModel: The hasOne relationship with the child. In this case "product".
				searchtype:"products",
				searchby:"Name",
				saveas:"ProductID",
				optionkey:"ProductID", //Since field and saveas aren't always unique values, they're no good for keys we'd like to use from the DB
				childrelationship:true,
				nestedmodel:"product",
				endadornment:<>this</>,
				autocompletelimit:25,
				debounce:1000,
				autocompletestatic:false, //If true, setup values
				autocompletevalues:[],
				borders:"all",
				columnoption:true,
				columnoptionlabel:"Product"
			},
			{
				field: "NewCheckbox",
				visible: true,
				columnheader: "text", //Requires columnheadertext and allowsort
				columnheadertext: "NewCheckbox",
				columnheaderalign: "left", //left, right, center
				columnheaderstyle: { width: "400px" }, //Raw inline css
				valuetextalign:"center",
				allowsort: true,
				defaultsortorder: "asc",
				editable: true,
				requiresref:false,
				render: "checkbox",
				borders:"all",
				columnoption:true,
				columnoptionlabel:"New Checkbox"
			},
			{
				field: "DateTime",
				visible: true,
				columnheader: "text", //Requires columnheadertext and allowsort
				columnheadertext: "Date",
				columnheaderalign: "left", //left, right, center
				columnheaderstyle: { width: "400px" }, //Raw inline css
				valuetextalign:"left",
				allowsort: true,
				defaultsortorder: "asc",
				editable: true,
				requiresref:false,
				render: "datetime",
				datetimeformat:"friendly", //"friendly",
				borders:"all",
				columnoption:true,
				columnoptionlabel:"Datetime"
			},
			

		],

		//Controls how edit mode will traverse editable cells.
		taborder:["Cost", "PositiveInteger"],

		// buttonsold:{
		// 	Save:{
		// 		visible:true
		// 	},
		// 	PendingSave:{
		// 		visible:true
		// 	},
		// 	AddRow:{
		// 		visible:true
		// 	},
		// 	AddItem:{
		// 		visible:true
		// 	},
		// 	ViewOptions:{
		// 		visible:true
		// 	}
		// }

		buttons: [
			{
				type:"Save",
				visible:true,
				perm:(userPerms['updateDemoData']===1 ? true : false)
			},{
				type:"PendingSave",
				visible:true,
				perm:(userPerms['updateDemoData']===1 ? true : false)
			},{
				type:"AddRow",
				visible:true,
				perm:(userPerms['createDemoData']===1 ? true : false)
			},{
				type:"AddItem",
				visible:true,
				perm:(userPerms['createDemoData']===1 ? true : false)
			},{
				type:"ViewOptions",
				visible:true,
				perm:true
			},{
				type:"EditItems",
				visible:true,
				perm:(userPerms['updateDemoData']===1 ? true : false)
			},{
				type:"Export",
				visible:true,
				perm:true
			},{
				type:"ItemList",
				visible:true,
				perm:true,
				title:"Item List",
				description: "Filter grid results by item <Name, ID, Sku, etc>.",
				itemlistkey:"Name"
			},{
				type:"Reset",
				visible:true,
				perm:true
			}
		],

		bulkeditcolumns: [
			{
				field:"Name",
				label:"Name",
				changetype:"text",
				maxlength:15,
				minlength:3
			},{
				field:"Cost",
				label:"Cost",
				changetype:"float", //Float, you can specify if you want below-zero values.
				maxval:1000000000,
				minval:0,
				precision:4
			},{
				field:"Price",
				label:"Price",
				changetype:"float",
				maxval:1000000000,
				minval:0
			},{
				field:"PositiveInteger",
				label:"Positive Integer",
				changetype:"integer", //Positive Integer
				maxval:1000000000,
				minval:0
			},{
				field:"SomeBoolean", 
				label:"Some Boolean",
				changetype:"select",
				menuitems:
				[
					{
						value:0,
						label:"No"
					},{
						value:1,
						label:"Yes"
					},{
						value:null,
						label:"Unknown (null, if capable)"
					}
				],
				default:{
					value:0,
					label:"No"
				},
			},{
				field:"NewCheckbox", 
				label:"New Checkbox",
				changetype:"checkbox", //Special bool to show checkbox
				default:false,
			},{
				field:"Date", 
				label:"Date",
				changetype:"date", //Date
				default:false, //Possibly send a default? "now"? "1yrago"? //For now false, no default.
			},{
				field:"DateTime", 
				label:"Date Time",
				changetype:"datetime", 
				default:false,
			},{
				field:"SomeSelectable", 
				label:"Some Selectable Custom",
				changetype:"customselect",
				customoptions:[
					<MenuItem value={0}>
								<em>Zero</em>
							</MenuItem>,
							<MenuItem value={null}>None - null</MenuItem>,
							<MenuItem value="">Blank</MenuItem>,
							<MenuItem value={10}>10</MenuItem>,
							<MenuItem value={"Adam"}>
								<div style={{ borderRadius: "5px", color: "#FFF", backgroundColor: "#45b84a", padding: "2px 5px 0px 5px" }}>Adam Taylor</div>
							</MenuItem>,


							<MenuItem value={"A"}><div style={{ borderRadius: "5px", color: "#FFF", backgroundColor: "#45b84a", padding: "2px 5px 0px 5px" }}>Grade A</div></MenuItem>,
							<MenuItem value={"B"}><div style={{ borderRadius: "5px", color: "#FFF", backgroundColor: "#ccb136", padding: "2px 5px 0px 5px" }}>Grade B</div></MenuItem>,
							<MenuItem value={"C"}><div style={{ borderRadius: "5px", color: "#FFF", backgroundColor: "#ce823e", padding: "2px 5px 0px 5px" }}>Grade C</div></MenuItem>,
							<MenuItem value={"Repair"}><div style={{ borderRadius: "5px", color: "#FFF", backgroundColor: "#e9523a", padding: "2px 5px 0px 5px" }}>Repair</div></MenuItem>,
							<MenuItem value={"Scrap"}><div style={{ borderRadius: "5px", color: "#FFF", backgroundColor: "#777", padding: "2px 5px 0px 5px" }}>Scrap</div></MenuItem>,
							<MenuItem value={"Unknown"}><div style={{ borderRadius: "5px", color: "#FFF", backgroundColor: "#999", padding: "2px 5px 0px 5px" }}>Unknown</div></MenuItem>,
				],
				defaultvalue:false,
			},{
				field:"ProductID",
				label:"Product",
				changetype:"autocomplete",
				searchby:"Name",
				searchtype:"products",
				saveas:"ProductID",
				optionkey:"ProductID", //Since field and saveas aren't always unique values, they're no good for keys we'd like to use from the DB
				autocompletelimit:30,
				debounce:1000,
				childrelationship:true,
				nestedmodel:"product",
				defaultvalue:{
					key:uuidv4(),
					Name:"Default Product",
					ProductID:0
				}
			},{
				field:"DateTime", 
				label:"Date Time",
				changetype:"datetime",
				defaultvalue:new dayjs(),
			},{
				field:"DeleteItems",
				label:"Delete Items",
				changetype:"deleteitems"
			}

		],

		exportoptions:{
			limit:10000,
			exportmessage: "Exports of search results will be limited to your selection or the first "+10000+" rows of your current search.",
			filename:"BasicTableCSV",
			columns: [
				{ column: "ID", label: "ID" },
				{ column: "Name", label: "Name" },
				{ column: "ProductID", label: "ProductID" },
				{ column: "product.Name", label: "Product Name" },
				{ column: "Cost", label: "Cost"},
				{ column: "Price", label: "Price"},
				{ column: "PositiveInteger", label: "PositiveInteger"},
				{ column: "SomeBoolean", label: "SomeBoolean"},
				{ column: "NewCheckbox", label: "NewCheckbox"},
				{ column: "DateTime", label: "Date", dateFormat: "YYYY-MM-DD HH:mm"},
			],

			exporttypes:[
				{label:"Simple",
					removevalues:[
						'ID'
					]
				}
			]
		}
	}





	/* 
				░█████████                               ░██                     
				░██     ░██                              ░██                     
				░██     ░██  ░███████  ░████████   ░████████  ░███████  ░██░████ 
				░█████████  ░██    ░██ ░██    ░██ ░██    ░██ ░██    ░██ ░███     
				░██   ░██   ░█████████ ░██    ░██ ░██    ░██ ░█████████ ░██      
				░██    ░██  ░██        ░██    ░██ ░██   ░███ ░██        ░██      
				░██     ░██  ░███████  ░██    ░██  ░█████░██  ░███████  ░██                                                                                                                 
	*/

	return (<FlexiGrid configuration={configuration} classes={classes} perms={perms}/>);
}

export default BoilerplateFlexiGrid;